export interface LoaderState {
  show: boolean;
  loaderType: loaderTypes;
}

export enum loaderTypes {
  default = 'DEFAULT',
  none = 'NONE',
  mainAnimation = 'MAIN_ANIMATION',
  secondAnimation = 'SECOND_ANIMATION',
}
